import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Dropdown } from "flowbite-react";
import { BiChevronDown, BiChevronRight } from "react-icons/bi";

const RecursiveDropdown = ({ categories, selectedCategory, setSelectedCategory }) => {
    const [openCategory, setOpenCategory] = useState(null);

    // Group categories by parent id
    const childrenMap = categories.reduce((acc, category) => {
        if (!acc[category.parent]) acc[category.parent] = [];
        acc[category.parent].push(category);
        return acc;
    }, {});

    const getChildren = (id) => childrenMap[id] || [];

    const getCategoryNameById = (id) => {
        const cat = categories.find((c) => c.id === id);
        return cat ? cat.name : "Select category";
    };

    const renderSubMenu = (
        parentId,
        depth = 0,
        parentName =
            <Button color="light" className="tw-flex tw-items-center tw-gap-2">
                <span>{getCategoryNameById(selectedCategory) || "Select category"}</span>
                <BiChevronDown size={20} className="ms-3" />
            </Button>
    ) => {
        const children = getChildren(parentId);
        if (!children.length) return null;

        return (
            <Dropdown label=""
                dismissOnClick={false}
                renderTrigger={() => <span>{parentName}</span>}
                placement={parentId ? "right-start" : "bottom"}
            >
                {children.map((category) => {
                    const subChildren = getChildren(category.id);
                    const isOpen = openCategory === category.id;

                    return (
                        <>

                            {
                                // isOpen && 
                                subChildren.length > 0 ?
                                    renderSubMenu(
                                        category.id,
                                        depth + 1,
                                        <Dropdown.Item
                                            className="flex justify-between items-center w-48 relative group p-0"
                                            key={category.id}
                                        >
                                            <span
                                                className="py-2 ps-4 pe-2"
                                                onClick={() => setSelectedCategory(category.id)}
                                            >
                                                {category.name}
                                            </span>
                                            {subChildren.length > 0 && (
                                                <span
                                                    className="py-2 px-2 hover:bg-gray-300 flex justify-content-center"
                                                    onMouseEnter={() => setOpenCategory(category.id)}
                                                >
                                                    <BiChevronRight size={20} />
                                                </span>
                                            )}
                                        </Dropdown.Item>
                                    )
                                    :
                                    <Dropdown.Item
                                        className="flex justify-between items-center w-48 relative group"
                                        key={category.id}
                                        onClick={() => setSelectedCategory(category.id)}
                                    >
                                        {category.name}
                                    </Dropdown.Item>
                            }
                        </>
                    );
                })}
            </Dropdown>
        );
    };

    return (
        <div className="mb-6 flex justify-center">
            {renderSubMenu(0)}
        </div>
    );
};

RecursiveDropdown.propTypes = {
    categories: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            parent: PropTypes.number.isRequired,
        })
    ).isRequired,
};

export default RecursiveDropdown;
